import { Stack, type SxProps } from '@mui/material';
import type { ReactNode } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

interface Props {
  surface?: boolean;
  noBackground?: boolean;
  sx?: SxProps;

  children: ReactNode;
}
export default function Toolbar({ surface, noBackground, sx, children }: Props) {
  return (
    <Stack
      direction="row"
      // Filter/action toolbars are interactive-only chrome — print styles hide them (see app print.css)
      data-print-hidden
      sx={{
        alignItems: 'start',
        gap: 2.5,

        backgroundColor: noBackground
          ? 'transparent'
          : surface
            ? `oklch(from ${campaignManagerTheme.color.groundZeroSurface} calc(l - 0.028) calc(c + 0.001) h / 0.95)`
            : `oklch(from ${campaignManagerTheme.color.groundZeroSurface} calc(l + 0.008) calc(c + 0.0015) h / 0.95)`,

        boxShadow: noBackground
          ? 'none'
          : `
            inset 0 1px 0 0 rgba(255, 255, 255, 0.5),
            inset 0 -1px 0 0 rgba(0, 0, 0, 0.02)
          `,

        pl: 1,
        pr: 3,
        pt: 1,
        pb: 0.825,
        borderRadius: 2,
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
}
